
  <qai-flex-container
    [direction]="'row'"
    [justifyContent]="'flex-start'"
    [flexWrap]="'wrap'"
    [background]="'transparent'"
    [gap]="'var(--spacing-3xl)'"
    [alignItems]="'normal'"
    [border]="false"
  >
    @for (card of insightCards; track card.id) {
      <qai-call-insight-card
        [heading]="card.heading"
        [description]="card.description"
        [headingMode]="card.headingMode"
        [descriptionMode]="card.descriptionMode"
        [showLink]="card.showLink"
        [subHeading]="card.subHeading"
        [subheadingIcon]="card.subheadingIcon"
        class="insight-card"
      >
        <qai-progress-bar
          [value]="card.progressBar.value"
          [max]="card.progressBar.max"
          [kind]="card.progressBar.kind"
          [shape]="card.progressBar.shape"
          [size]="card.progressBar.size"
          [label]="card.progressBar.label"
          [labelVariant]="card.progressBar.labelVariant"
          [description]="card.progressBar.description"
          [segments]="card.progressBar.segments"
          [ariaLabel]="card.progressBar.ariaLabel"
        ></qai-progress-bar>
      </qai-call-insight-card>
    }
  </qai-flex-container>

